import { useMainStore } from '~/store'

export const useLocaleSEO = (tempSEO) => {
  let seo = { meta: []}
  const route = useRoute()
  const store = useMainStore()
  // Set static copyright tag
  seo.meta.push({
    hid: 'copyright',
    name: 'copyright',
    content: new Date().getFullYear() + ' All Rights Reserved'
  })
  // Set og:url tag
  let current_route = route
  let current_url = ''
  const current_route_name = current_route.name || ''

  if (current_route_name.includes('index')) {
    current_url = store.propertyData.url
  } else {
    current_url = store.propertyData.url + route.fullPath
  }

  seo.meta.push({
    hid: 'og:url',
    name: 'og:url',
    content: current_url
  })
  
  //Set og:type tag
  seo.meta.push({
    hid: 'og:type',
    name: 'og:type',
    content: 'website'
  })

  if (tempSEO) {
    //update seo
    if (tempSEO.value.meta_title) {
      seo.title = tempSEO.value.meta_title
      seo.meta.push({
        hid: 'title',
        name: 'title',
        content: tempSEO.value.meta_title
      })
      //for facebook scrapping
      seo.meta.push({
        hid: 'og:title',
        name: 'og:title',
        content: tempSEO.value.meta_title
      })
    }

    if (tempSEO.value.meta_description) {
      seo.meta.push({
        hid: 'description',
        name: 'description',
        content: tempSEO.value.meta_description
      })
      //for facebook scrapping
      seo.meta.push({
        hid: 'og:description',
        name: 'og:description',
        content: tempSEO.value.meta_description
      })
    }

    if (tempSEO.value.meta_keywords) {
      seo.meta.push({
        hid: 'keywords',
        name: 'keywords',
        content: tempSEO.value.meta_keywords
      })
    }

    if (tempSEO.value.image_url) {
      seo.meta.push({
        hid: 'image',
        name: 'image',
        content: tempSEO.value.image_url
      })

      //for facebook scrapping
      seo.meta.push({
        hid: 'og:image',
        property: 'og:image',
        content: tempSEO.value.image_url.includes('https:')
          ? tempSEO.value.image_url.replace('https:', 'http:')
          : tempSEO.value.image_url
      })
      seo.meta.push({
        hid: 'og:image:secure',
        property: 'og:image:secure',
        content: tempSEO.value.image_url
      })
      seo.meta.push({
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: tempSEO.value.image_url
      })
    }

    if (tempSEO.value.canonical) {
      //canonical tag
      seo.link = []
      seo.link.push({
        rel: 'canonical',
        href: tempSEO.value.canonical
      })
    }
  }
  return seo
}